import client from './client';

export interface StaffUser {
  id: string;
  email: string | null;
  full_name: string | null;
  phone: string | null;
  role: 'admin' | 'moderator' | 'operator' | string;
}

interface LoginResponse {
  access_token: string;
  refresh_token: string;
  user: StaffUser;
}

export const authApi = {
  /** Вход сотрудника по почте и паролю. */
  login: (email: string, password: string) =>
    client.post<LoginResponse>('/api/admin/auth/login', { email, password }),

  /** Кто я — проверка токена при загрузке панели. */
  getMe: () => client.get<StaffUser>('/api/admin/auth/me'),

  /** Запросить письмо со ссылкой на смену пароля. */
  forgotPassword: (email: string) =>
    client.post<{ message: string }>('/api/admin/auth/forgot-password', { email }),

  /** Проверить ссылку из письма до ввода пароля. */
  resetInfo: (token: string) =>
    client.get<{ email: string; full_name: string | null; kind: 'invite' | 'reset' }>(
      '/api/admin/auth/reset-info',
      { params: { token } },
    ),

  /** Задать пароль по ссылке из письма — сразу входит. */
  resetPassword: (token: string, password: string) =>
    client.post<LoginResponse>('/api/admin/auth/reset-password', { token, password }),

  /** Сменить свой пароль, зная текущий. */
  changePassword: (current_password: string, new_password: string) =>
    client.post<{ message: string }>('/api/admin/auth/change-password', {
      current_password,
      new_password,
    }),
};
